import { FC, PropsWithChildren } from 'react';
import { PageHeader, UserWidgetProps } from '../../organisms/PageHeader';
import {
  StyledConstrainedContent,
  StyledConstrainedLayout,
} from './ConstrainedLayout.styles';
import { PageHeading } from '../../atoms/PageHeading';

interface ConstrainedLayoutProps extends PropsWithChildren {
  userWidget: UserWidgetProps;
  heading: {
    title: string | JSX.Element;
    subtitle?: string | JSX.Element;
    loading?: boolean;
  };
}

/**
 * Simple layout with header and footer. Content is constrained within a centered, max-width container.
 */
export const ConstrainedLayout: FC<ConstrainedLayoutProps> = ({
  children,
  userWidget: { login, logout, userPhoto, userName },
  heading: { title, subtitle, loading },
}) => {
  return (
    <StyledConstrainedLayout>
      <StyledConstrainedContent>
        <PageHeader
          login={login}
          logout={logout}
          userPhoto={userPhoto}
          userName={userName}
        />
        <PageHeading
          data-testid="heading"
          title={title}
          subtitle={subtitle}
          loading={loading}
        />
        {children}
      </StyledConstrainedContent>
    </StyledConstrainedLayout>
  );
};

export default ConstrainedLayout;
